import { Navigate } from 'react-router-dom';

/** “Reset password” in the menu points here; same OTP flow as forgot password. */
const AccountResetRedirect = () => <Navigate to="/account/forgot-password?from=reset" replace />;

export default AccountResetRedirect;
